import React from "react";
import { Link } from "react-router-dom";
import { getOptimizedImageUrl } from "../lib/cms";

export default function ServiceCard({
  title,
  tagline,
  teaser,
  image,
  linkUrl,
}) {
  return (
    <Link
      to={linkUrl}
      className="group rounded-2xl overflow-hidden flex flex-col justify-between transition-all duration-300 bg-white border border-[#E2D8C7] shadow-sm hover:shadow-xl hover:border-[#1E4231]/30 cursor-pointer"
    >
      <div>
        {/* Card Image */}
        <div className="relative aspect-[16/10] overflow-hidden bg-[#E7DFD2]">
          {image ? (
            <img
              src={getOptimizedImageUrl(image, 640, 80)}
              alt={title}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          ) : (
            <div className="w-full h-full bg-[#1D3C2C] flex items-center justify-center">
              <i className="fa-solid fa-tree text-white/30 text-4xl" aria-hidden="true" />
            </div>
          )}
        </div>

        {/* Content */}
        <div className="p-6 sm:p-7 space-y-3">
          {tagline && (
            <span className="text-xs font-bold uppercase tracking-wider text-[#2A5C41] block">
              {tagline}
            </span>
          )}

          <h3 className="text-xl sm:text-2xl font-bold text-[#14291E] tracking-tight group-hover:text-[#1E4231] transition-colors">
            {title}
          </h3>

          <p className="text-sm text-[#4E685A] leading-relaxed line-clamp-4">
            {teaser}
          </p>
        </div>
      </div>

      {/* Action footer */}
      <div className="px-6 pb-6 pt-2">
        <span
          className="inline-flex items-center justify-between w-full px-4 py-3 rounded-xl font-bold text-sm transition-all duration-200 bg-[#1E4231] group-hover:bg-[#285741] text-white shadow-sm"
        >
          <span>Læs mere</span>
          <i className="fa-solid fa-arrow-right text-xs group-hover:translate-x-1 transition-transform" aria-hidden="true" />
        </span>
      </div>
    </Link>
  );
}
